import { useState, useEffect } from 'react'
import { FieldValues, UseFormMethods } from 'react-hook-form'
import { Dispatch } from 'react-router/node_modules/@types/react'

const usePromptForm = <T extends FieldValues>(
  methods: UseFormMethods<T>,
): [boolean, Dispatch<boolean>] => {
  const [shouldPrompt, setShouldPrompt] = useState<boolean>(false)

  useEffect(() => {
    if (shouldPrompt || methods.formState.isSubmitting) {
      return
    }

    if (methods.formState.isDirty) {
      setShouldPrompt(true)
    }
  }, [methods.formState])

  return [shouldPrompt, setShouldPrompt]
}

export default usePromptForm
